import { useAccountUpdateSettingsMutation } from '~/generated/graphql';

export function useUpdateAccountSettings() {
  const [updateAccountSettings] = useAccountUpdateSettingsMutation();

  return {
    updateAccountSettings,
  };
}
